
// import { SupportAnnounce6Component } from "./SupportAnnounce6Component";
import { SupportAnnounce6Component } from "./current/SupportAnnounce6Component";
export function DetailSupportFormAnnounce6Component() {
    return (
        <SupportAnnounce6Component />
    );

}
